import React from 'react'
import Header from './Header';
import Image from './Image';
import {Menu,Container} from 'semantic-ui-react';
import Content from './Content';
import Projects from './Projects';
import Connect from './Connect';
import { useEffect } from 'react';

import './App.css'

function App() {


  useEffect(() => {
   
    document.title="MyPortfolio"
  }, [])


  return (
    <div className="maindiv">
      <Container>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.4.1/semantic.min.css" integrity="sha512-8bHTC73gkZ7rZ7vpqUQThUDhqcNFyYi2xgDgPDHc+GXVGHXq+xPjynxIopALmOPqzo9JZj0k6OqqewdGO3EsrQ==" crossorigin="anonymous" referrerpolicy="no-referrer" />
      
      <Header></Header>
      <Image></Image>
      <Content></Content>
      <hr></hr>
      <Projects></Projects>
      <hr></hr>
      <Connect></Connect>
      </Container>
    </div>
  )
}

export default App
